import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  loginInvalid = false;

  constructor(private authService: AuthService, private router:Router) { }

  ngOnInit(): void {
    if (localStorage.getItem('@auth-token')) {
      this.router.navigateByUrl('home');
    }
    this.form = new FormGroup({
      username: new FormControl(null),
      password: new FormControl(null)
    })
  }

  async onSubmit() {
    this.loginInvalid = false;
    if (this.form.valid) {
      try {
        const username = this.form.get('username')?.value;
        const password = this.form.get('password')?.value;
        const data = await this.authService.authenticate(username, password);
        
        localStorage.setItem('@auth-token', data.accessToken);
        location.href = '/home';

      } catch (err) {
        this.loginInvalid = true;
      }
    }
  }

}
